import coreJS from 'core-js'; // 추가된 부분
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';

import "./_define/Option";
import './styles/app.css';

import i18nConfiguration from './i18n';
import configureStore from './store/store';

// cat. into common modules
let BUILD_DATE = "20260907_162616";
let BUILD_VERSION = "1.3.12";
if (process.env.NODE_ENV !== 'development') {
    function noop() {
    }

    if (process.env.NODE_ENV !== 'development') {
        console.log = noop;
        // console.warn = noop;
        // console.error = noop;
    }
}
console.warn(BUILD_VERSION);
console.warn(BUILD_DATE);

ReactDOM.render(<div/>, document.getElementById('into-app'));

i18nConfiguration(() => {
    import('./App').then((module) => {
        const store = configureStore();
        const {default: App} = module;

        ReactDOM.render(
            <Provider store={store}>
                <App/>
            </Provider>,
            document.getElementById('into-app')
        );
    });
});
